<div style="padding-top: 2em;">
  <app-main-heading headingText="Medlemsopslag"></app-main-heading>
  <mat-form-field appearance="outline" style="margin-top:1em;width:100%;max-width:400px;">
    <mat-label>Emailadresse</mat-label>
    <input matInput placeholder="Email" type="email" [(ngModel)]="email" [disabled]="loading" autocomplete="off" data-1p-ignore (keyup.enter)="lookupMember()" />
    <mat-icon matSuffix (click)="lookupMember()" [ngStyle]="{ 'cursor': loading ? 'wait' : 'pointer' }">search</mat-icon>
  </mat-form-field>
  <hr />
  @if (lookupResult$ | async; as lookupResult) {
  @if (lookupResult.success) {
  <h4>Butiksvalg &amp; Permission</h4>
  <table>
    <tbody>
      <tr>
        <th>Butik</th>
        <td>@if (lookupResult.storeId) {
          {{ lookupResult.storeId || '' }}{{ lookupResult.storeName ? ' - ' + lookupResult.storeName : '' }}
          } @else {
          <i>Ingen butik valgt</i>
          }
        </td>
      </tr>
      <tr>
        <th>Gyldig email</th>
        <td>{{ lookupResult.validEmail ? 'Ja' : 'Nej' }}</td>
      </tr>
      <tr>
        <th>Club Matas permission</th>
        <td>{{ lookupResult.permissionClubMatas ? 'Ja' : 'Nej' }}</td>
      </tr>
      <tr>
        <th>Butikspermission</th>
        <td>{{ lookupResult.permissionStore ? 'Ja' : 'Nej' }}</td>
      </tr>
    </tbody>
  </table>

  @if (lookupResult.communicationsHistoryEntries && lookupResult.communicationsHistoryEntries.length > 0) {
  <h4 style="margin-top:2em;">Udsendelser seneste 90 dage</h4>
  <table>
    <thead>
      <tr>
        <th>Udsendelsesskabelon</th>
        <th>Dato</th>
      </tr>
    </thead>
    <tbody>
      @for (sendout of lookupResult.communicationsHistoryEntries; track $index) {
      <tr>
        <td>{{ sendout.name }}</td>
        <td>
          {{ sendout.sentAt | dfnsParseIso | dfnsFormat : 'dd.MM.yyyy' }}
        </td>
      </tr>
      }
    </tbody>
  </table>
  }
  } @else {
  <p><em>Medlemmet kunne ikke findes</em></p>
  }
  }
</div>
